<template>
  <div>
    <div class="alert_popup" v-if="_modal.alertState">
      <div class="popup_con">
        <div class="txt_container">
          <p class="txt" v-html="_modal.msg"></p>
        </div>
        <button type="button" class="btn_fill" @click="closeAlert">확인</button>
      </div>
    </div>
    <div class="alert_popup" v-if="_modal.alertTitleState">
      <div class="popup_con_title">
        <p class="title" v-html="_modal.title"></p>
        <div class="txt_container">
          <p class="txt" v-html="_modal.msg"></p>
        </div>
        <button type="button" class="btn_fill" @click="closeAlert">확인</button>
      </div>
    </div>
    <div class="alert_popup" v-if="_modal.alertContentNextState">
      <div class="popup_con">
        <div class="txt_container">
          <p class="txt" v-html="_modal.msg"></p>
        </div>
        <button type="button" class="btn_fill" @click="confirmAlert">
          {{ _modal.btn_msg }}
        </button>
      </div>
    </div>
    <div class="popWrap creatCheck02" v-if="_modal.confirmState">
      <div class="popCon">
        <div class="contents">
          <p
            class="alertBox"
            style="white-space: pre-line"
            v-html="_modal.msg"
          ></p>
          <div class="btnWrap02">
            <button type="button" class="btnCnl" @click="closeAlert">
              {{ _modal.btn_cl }}
            </button>
            <button type="button" class="btnChk" @click="confirmAlert">
              {{ _modal.btn_co }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="popWrap creatCheck02" v-if="_modal.confirmCancelState">
      <div class="popCon">
        <div class="contents">
          <p
            class="alertBox"
            style="white-space: pre-line"
            v-html="_modal.msg"
          ></p>
          <div class="btnWrap02">
            <button type="button" class="btnCnl" @click="cancelAlert">
              {{ _modal.btn_cl }}
            </button>
            <button type="button" class="btnChk" @click="confirmAlert">
              {{ _modal.btn_co }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="popWrap creatCheck02" v-if="_modal.loginState">
      <div class="popCon">
        <div class="contents">
          <p class="alertBox" style="white-space: pre-line; text-align: center">
            {{ _modal.msg }}
          </p>
          <div class="btnWrap02">
            <button
              type="button"
              class="btnCnl"
              @click="closeSubscribeAlert"
              style="width: 30%"
            >
              취소
            </button>
            <button
              type="button"
              class="btnChk"
              @click="confirmAlert"
              style="width: 60%"
            >
              3초만에 로그인
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="popWrap creatCheck02" v-if="_modal.customConfirmState">
      <div class="popCon">
        <div class="contents">
          <p
            class="alertBox"
            style="white-space: pre-line"
            v-html="_modal.msg"
          ></p>
          <div class="btnWrap02">
            <button
              type="button"
              class="btnCnl custom_cnl"
              @click="customCloseAlert"
            >
              {{ _modal.btn_cl_custom }}
            </button>
            <button
              type="button"
              class="btnChk custom_chk"
              @click="customConfirmAlert"
            >
              {{ _modal.btn_co_custom }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="alert_popup" v-if="_modal.customConfirmStateTitleContent">
      <div class="popup_con_title">
        <p class="title" v-html="_modal.title"></p>
        <div class="txt_container" style="margin-bottom: 24px">
          <p class="txt" v-if="_modal.msg" v-html="_modal.msg"></p>
        </div>
        <!-- <button type="button" class="btn_fill" @click="closeAlert">확인</button> -->
        <div class="two-btn-group">
          <button
            type="button"
            class="two-btn-group-left"
            @click="customCloseAlert"
          >
            {{ _modal.btn_cl_custom }}
          </button>
          <button
            type="button"
            class="two-btn-group-right"
            @click="customConfirmAlert"
          >
            {{ _modal.btn_co_custom }}
          </button>
        </div>
      </div>
      <div class="alert_popup" v-if="_modal.customConfirmStateTitleContent1Btn">
        <div class="popup_con_title">
          <p class="title" v-html="_modal.title"></p>
          <div class="txt_container" style="margin-bottom: 24px">
            <p class="txt" v-if="_modal.msg" v-html="_modal.msg"></p>
          </div>
          <!-- <button type="button" class="btn_fill" @click="closeAlert">확인</button> -->
          <div class="two-btn-group">
            <button
              type="button"
              class="two-btn-group-right"
              @click="customConfirmAlert"
            >
              {{ _modal.btn_co_custom }}
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="popCon">
        <div class="contents">
          <div class="popup_con">
            <p class="title" v-html="_modal.title"></p>
            <div class="txt_container">
              <p class="txt" v-html="_modal.msg"></p>
            </div>
          </div>
          <div class="btnWrap02">
            <button
              type="button"
              class="btnCnl custom_cnl"
              @click="customCloseAlert"
            >
              {{ _modal.btn_cl_custom }}
            </button>
            <button
              type="button"
              class="btnChk custom_chk"
              @click="customConfirmAlert"
            >
              {{ _modal.btn_co_custom }}
            </button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

require("@/assets/css/popup.css");

export default {
  name: "AlertPopup",
  props: ["context", "test"],
  data() {
    return {
      idx: 0,
    };
  },
  computed: {
    ...mapState(["_state", "_modal"]),
  },
  methods: {
    fnResetAlert() {
      this._modal.msg = "";
      this._modal.alertBool = false;
      this._modal.alertState = false;
      this._modal.alertTitleState = false;
      this._modal.alertContentNextState = false;
      this._modal.confirmState = false;
      this._modal.loginState = false;
      this._modal.confirmCancelState = false;
      this._modal.event = "";
      this._modal.event02 = "";
      this._modal.btn_msg = "";
      this._modal.customConfirmState = false;
      this._modal.customConfirmStateTitleContent = false;
      this._modal.customConfirmStateTitleContent1Btn = false;
      this._modal.btn_cl_custom = "";
      this._modal.btn_co_custom = "";
    },
    closeAlert() {
      this.fnResetAlert();
    },
    closeSubscribeAlert() {
      this.fnResetAlert();
    },
    confirmAlert() {
      this._modal.event();
      this.fnResetAlert();
    },
    cancelAlert() {
      this._modal.event02();
      this.fnResetAlert();
    },
    withDrawAlert() {
      this.fnResetAlert();
      this.$router.push("/mypage");
    },
    customConfirmAlert() {
      if (this._modal.event) this._modal.event();
      this.fnResetAlert();
    },
    customCloseAlert() {
      if (this._modal.event02) this._modal.event02();
      this.fnResetAlert();
    },
  },
};
</script>
<style scoped>
.alert_popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99999;
}
.alert_popup .popup_con {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 462px;
  min-height: 224px;
  border-radius: 20px;
  background-color: #fff;
  padding: 20px;
  max-height: 80%;
}
.alert_popup .popup_con .txt_container {
  margin-top: 10px;
  margin-bottom: 20px;
  max-height: 50vh;
  overflow-y: scroll;
}
/* .alert_popup .popup_con .txt {
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    padding-left: 30px;
    padding-right: 30px;
    color: #2B2B2B;
} */
.alert_popup .popup_con p {
  text-align: center;
  font-size: 17px;
  padding-left: 30px;
  padding-right: 30px;
}
.alert_popup .popup_con .close {
  position: absolute;
  right: 30px;
  top: 30px;
}
.alert_popup .popup_con .btn_fill {
  display: block;
  margin: 15px auto 0;
  width: 100%;
  height: 44px;
  min-height: 45px;
  border-radius: 10px;
  background-color: #5087ff;
  color: #fff;
}

.alert_popup .popup_con_title {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 343px;
  border-radius: 20px;
  background-color: #fff;
  padding: 20px;
  max-height: 80%;
}
.alert_popup .popup_con_title .title {
  text-align: left;
  font-size: 17px;
  font-weight: 500;
  color: #2b2b2b;
}
.alert_popup .popup_con_title .txt_container {
  margin-top: 10px;
  margin-bottom: 20px;
  max-height: 50vh;
  overflow-y: scroll;
}
.alert_popup .popup_con_title .txt {
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #2b2b2b;
}
.alert_popup .popup_con_title .close {
  position: absolute;
  right: 30px;
  top: 30px;
}
.alert_popup .popup_con_title .btn_fill {
  display: block;
  width: 100%;
  height: 44px;
  min-height: 45px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 10px;
  background-color: #5087ff;
  color: #fff;
}

.alert_popup .popup_con .btn_custom_cnl {
  display: block;
  width: 100%;
  height: 44px;
  min-height: 45px;
}

.popWrap .btnWrap02 .btnCnl.custom_cnl {
  border-radius: 10px;
  background: var(--safe-25, #dde8ff);
  color: var(--Safe-main, #5087ff);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  border: none;
}

.popWrap .btnWrap02 .btnChk.custom_chk {
  border-radius: 10px;
  background: var(--Safe-main, #5087ff);
  color: var(--Grayscale-White, #fff);
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  border: none;
}

.two-btn-group {
  width: 100%;
  height: 44px;
  display: flex;
  gap: 11px;
  justify-content: space-between;
}
.two-btn-group-left {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: var(--safe-25, #dde8ff);
  color: var(--Safe-main, #5087ff);
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  border: none;
}
.two-btn-group-right {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: var(--Safe-main, #5087ff);
  color: var(--Grayscale-White, #fff);
  text-align: center;
  font-weight: 500;
  line-height: 20px;
  border: none;
}

@media screen and (max-width: 1080px) {
  .alert_popup .popup_con {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 322px;
    border-radius: 20px;
    background-color: #fff;
  }
  .alert_popup .popup_con_title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 322px;
    border-radius: 20px;
    background-color: #fff;
  }
}
</style>
